import { useLayoutEffect, useEffect } from 'react'
import { Platform } from 'react-native'

const useServerLayoutEffect =
  Platform.OS !== 'web' || typeof window !== 'undefined'
    ? useLayoutEffect
    : useEffect

export default useServerLayoutEffect
